import React from 'react'
import styled from 'styled-components'
import {POLICY_NAVBAR_ITEM_LABEL_WIDTH, POLICY_ROOT_MENU_HEIGHT} from 'consts'
import {Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {PolicyRootNavBarItemProps} from './PolicyRootNavBarItemProps'

interface StyledContainerProps {
  isSelected: boolean
  showLabel?: boolean
}

const StyledContainer = styled.div<StyledContainerProps>`
  ${({isSelected, theme}) => ({
    backgroundColor: isSelected ? theme.primary_5 : undefined,
  })}
  display: flex;
  width: ${convertUnit(POLICY_NAVBAR_ITEM_LABEL_WIDTH)};
  box-sizing: border-box;
  justify-content: space-between;
  border-radius: ${convertUnit(10)};
  margin: ${convertUnit(5)} ${convertUnit(18)};
  height: ${convertUnit(POLICY_ROOT_MENU_HEIGHT)};
  align-items: center;
  direction: ltr;
  :hover {
    cursor: pointer;
    background-color: ${({theme}) => theme.primary_5};
  }
  transition: all 0.15s ease-out;
`

const StyledLabel = styled(Paragraph)<StyledContainerProps>`
  :hover {
    color: ${({theme}) => theme.white_1};
  }
  width: 100%;
  box-sizing: border-box;
  padding: ${convertUnit(20)};
`

export default function PolicyRootNavBarItem({
  isSelected,
  label,
  onClick,
}: PolicyRootNavBarItemProps) {
  return (
    <StyledContainer
      isSelected={isSelected}
      onClick={isSelected ? undefined : onClick}>
      <StyledLabel
        isSelected={isSelected}
        fontWeight="bold"
        fontSize="l"
        color={isSelected ? 'white_1' : 'black'}>
        {label}
      </StyledLabel>
    </StyledContainer>
  )
}
